module.exports = __webpack_public_path__ + "img/button_4.1ba70b46.png";